import CallForImpactHall from './container';

export default CallForImpactHall;



// WEBPACK FOOTER //
// ./src/routes/CallForImpactHall/index.js